import React, {useState} from 'react';
import RecoveryTreeLogo from './RecoveryTreeLogo';

const LINKS = [
    {href: '#services', label: 'Services'},
    {href: '#start', label: 'Your first visit'},
    {href: '#questions', label: 'FAQs'},
    {href: '#refer-a-client', label: 'Refer a client'},
];

const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <nav className="sw-nav">
                <a href="#hero" className="sw-nav__brand">
                    <RecoveryTreeLogo/>
                    <div>
                        <p className="sw-nav__brand-name">STRATEGIC WELLNESS</p>
                        <p className="sw-nav__brand-sub">ADVOCATES LLC</p>
                    </div>
                </a>
                <div className="sw-nav__links">
                    {LINKS.map((link) => (
                        <a key={link.href} href={link.href} className="sw-nav__link">{link.label}</a>
                    ))}
                    <a href="#contact" className="sw-nav__cta">Request care</a>
                </div>
                <button
                    type="button"
                    className="sw-nav__toggle"
                    aria-label="Toggle navigation menu"
                    aria-expanded={open}
                    onClick={() => setOpen(!open)}
                >
                    {open
                        ? (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M6 6l12 12M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        ) : (
                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" aria-hidden="true">
                                <rect width="18" height="2" rx="1" fill="white"/>
                                <rect y="6" width="14" height="2" rx="1" fill="white"/>
                                <rect y="12" width="10" height="2" rx="1" fill="white"/>
                            </svg>
                        )}
                </button>
            </nav>
            <div className={`sw-nav-mobile${open ? ' is-open' : ''}`}>
                {LINKS.map((link) => (
                    <a key={link.href} href={link.href} onClick={() => setOpen(false)}>{link.label}</a>
                ))}
                <a href="#contact" onClick={() => setOpen(false)}>Request care</a>
            </div>
        </React.Fragment>
    );
};

export default Navbar;
